import { render, staticRenderFns } from "./GestionOptimiseurs.vue?vue&type=template&id=483726a4&"
import script from "./GestionOptimiseurs.vue?vue&type=script&lang=js&"
export * from "./GestionOptimiseurs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports